import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys, jobCostKeys } from '@/lib/queryKeys';
import type { Expense } from '@/types/settings';

export function useVoidExpense(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<
    Expense,
    { id: string; reason?: string; acknowledgedPurchaseOrderIds?: string[] }
  >({
    mutationFn: ({ id, reason, acknowledgedPurchaseOrderIds }) =>
      apiPost<Expense>(operationsClient, expenseEndpoints.void(jobId, id), {
        reason,
        acknowledgedPurchaseOrderIds,
      }),
    onSuccess: (_expense, { id }) => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      // Voiding backs the cost out of the visit actuals / job margin roll-up.
      void queryClient.invalidateQueries({ queryKey: jobCostKeys.summary(jobId) });
      void queryClient.invalidateQueries({ queryKey: ['purchase-orders'] });
      toast.success('Expense voided');
    },
  });
}
